import Footer from "./Footer";
import Header from "./Header";

function About() {
  return (
    <>
      <Header />

      {/* Hero Section */}
      <section className="pt-7 pb-2 bg-light">
        <div className="container text-center d-flex justify-content-center">
          <div className="col-lg-8 col-12">
            <h1 className="fw-normal ls-sm text-dark lh-1 mt-1">
              About GoRishtey.com
            </h1>
            <p className="text-muted fs-4 lh-sm mx-auto">
              GoRishtey.com is a modern matrimony & matchmaking platform built
              with a single purpose — to help individuals and families find
              meaningful, compatible, and lifelong relationships with trust,
              dignity, and care.
            </p>
          </div>
        </div>
      </section>

      {/* Who We Are */}
      <section className="pb-6">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <h2 className="fw-normal mb-3">Who We Are</h2>
              <p className="text-secondary lh-sm fs-4">
                GoRishtey.com is more than just a matrimony website — it is a
                thoughtfully designed matchmaking ecosystem that blends
                traditional values with modern technology.
              </p>
              <p className="text-secondary lh-sm fs-4">
                We understand that marriage is not just about two individuals,
                but about families, values, cultures, and lifelong commitment.
                Our platform is built to respect these sentiments while offering
                a safe, transparent, and user-friendly experience.
              </p>
            </div>
            <div className="col-lg-6 text-center">
              <img
                src="/assets/images/logo.png"
                alt="About GoRishtey"
                width="300"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Our Mission */}
      <section className="py-6 bg-red-primary text-white">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 text-center">
              <h1 className="fw-normal ls-sm text-white lh-1 mt-1">
                Our Mission
              </h1>
              <p className="fs-4 lh-sm mt-2">
                Our mission is to create genuine, meaningful, and successful
                marriages by connecting compatible individuals through verified
                profiles, intelligent matchmaking, and a secure environment
                built on trust.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-8">
        <div className="container">
          <div className="text-center mb-5 d-flex justify-content-center">
            <h2 className="col-lg-8 col-12 fw-normal ls-sm text-dark lh-1 mt-1">
              At GoRishtey.com, we believe that{" "}
              <span className="fw-bold">finding a life partner</span> is one of
              the most important decisions a person makes.
            </h2>
          </div>

          <div className="row g-2">
            <div className="col-md-6 col-lg-4">
              <div className="p-4 border rounded-4 bg-white shadow h-100">
                <h5 className="fw-semibold mb-2">Verified Profiles</h5>
                <p className="text-secondary lh-sm">
                  Every profile goes through strict checks to ensure
                  authenticity and reduce fake or misleading accounts.
                </p>
              </div>
            </div>

            <div className="col-md-6 col-lg-4">
              <div className="p-4 border rounded-4 bg-white shadow h-100">
                <h5 className="fw-semibold mb-2">Privacy First</h5>
                <p className="text-secondary lh-sm">
                  Your personal information is protected with industry-grade
                  security and full control over visibility.
                </p>
              </div>
            </div>

            <div className="col-md-6 col-lg-4">
              <div className="p-4 border rounded-4 bg-white shadow h-100">
                <h5 className="fw-semibold mb-2">Smart Matchmaking</h5>
                <p className="text-secondary lh-sm">
                  Matches are suggested based on preferences, values, lifestyle,
                  and compatibility — not random algorithms.
                </p>
              </div>
            </div>

            <div className="col-md-6 col-lg-4">
              <div className="p-4 border rounded-4 bg-white shadow h-100">
                <h5 className="fw-semibold mb-2">Family-Oriented Approach</h5>
                <p className="text-secondary lh-sm">
                  Designed keeping Indian family values in mind, making the
                  journey comfortable for both individuals and families.
                </p>
              </div>
            </div>

            <div className="col-md-6 col-lg-4">
              <div className="p-4 border rounded-4 bg-white shadow h-100">
                <h5 className="fw-semibold mb-2">Safe & Respectful</h5>
                <p className="text-secondary lh-sm">
                  We strictly prohibit misuse, fake profiles, or commercial
                  marriage bureaus to maintain a respectful environment.
                </p>
              </div>
            </div>

            <div className="col-md-6 col-lg-4">
              <div className="p-4 border rounded-4 bg-white shadow h-100">
                <h5 className="fw-semibold mb-2">Mobile & Web Experience</h5>
                <p className="text-secondary lh-sm">
                  Seamless experience across mobile apps and web, built for
                  speed, ease, and reliability.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Trust Statement */}
      <section className="py-6 bg-white">
        <div className="container text-center d-flex justify-content-center">
          <div className="col-lg-8 col-12">
            <h2 className="fw-semibold mb-2">Our Commitment to Trust</h2>
            <p className="text-secondary fs-5 lh-sm mx-auto">
              At GoRishtey.com, trust is not a feature — it is the foundation.
              From secure data handling to verified users and transparent
              policies, we are committed to helping you take one of life’s most
              important decisions with confidence and peace of mind.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default About;
